<gr-terms-first-step
  [urlParams]="urlParams"
  [termsData]="{isSecondStepChanges, terms: termsData}"
  [sameSlots]="sameSlots"
  [sameWorkTime]="sameWorkTime"
  (workingDaysChange)="workingDays = $event"
  (submitForm)="getTermsData()">
</gr-terms-first-step>
<gr-terms-second-step
  *ngIf="termsData?.calendars && termsData?.calendars?.length"
  [urlParams]="urlParams"
  [termsData]="termsData"
  [sameSlots]="sameSlots"
  [workingDays]="workingDays"
  (changeTermDate)="getTermsData(true)">
</gr-terms-second-step>
